/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Hydrid Access Control Resources
 * Critical resources accessed through either RBAC or ABAC :
 *   * SUBSCRIPTION
 *   * SERVICE
 *   * STATION
 */
export enum HacResources {
  SUBSCRIPTION = 'SUBSCRIPTION',
  SERVICE = 'SERVICE',
  STATION = 'STATION'
}
